import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function AlbanyProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Albany"
      headingExtra="GA"
      introText="Albany and southwest Georgia travelers have several options for getting an expedited passport. Here's how they compare — and why most Dougherty County residents choose a registered U.S. Department of State passport courier agency to handle their emergency passport needs."
      options={options}
      emergencyDescription="Atlanta is approximately 180 miles via I-75 (3+ hours each way). Georgia's single agency serves 11M+. Albany sits in the southwest corner of the state — the farthest metropolitan area from Atlanta's agency. The Flint River basin's rural highways offer no interstate connection for the first 60 miles. Albany State University sends students abroad every semester — a Ram discovering an expired passport 48 hours before Ghana faces a 7+ hour round trip through peanut country with no backup route. During hurricane evacuation season, I-75 clogs with Florida evacuees, turning 180 miles into 5+ hours. One agency. 11 million Georgians. And Albany is at the far end of the line."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}